// Get Batch Message Template
export const GET_BATCH_MESSAGE_TEMPLATE_REQUEST = 'GET_BATCH_MESSAGE_TEMPLATE_REQUEST';
export const GET_BATCH_MESSAGE_TEMPLATE_DONE = 'GET_BATCH_MESSAGE_TEMPLATE_DONE';
export const GET_BATCH_MESSAGE_TEMPLATE_FAILED = 'GET_BATCH_MESSAGE_TEMPLATE_FAILED';

// Update Batch Message Template
export const UPDATE_BATCH_MESSAGE_TEMPLATE_REQUEST = 'UPDATE_BATCH_MESSAGE_TEMPLATE_REQUEST';
export const UPDATE_BATCH_MESSAGE_TEMPLATE_DONE = 'UPDATE_BATCH_MESSAGE_TEMPLATE_DONE';
export const UPDATE_BATCH_MESSAGE_TEMPLATE_FAILED = 'UPDATE_BATCH_MESSAGE_TEMPLATE_FAILED';
export const UPDATE_BATCH_MESSAGE_TEMPLATE_RESET = 'UPDATE_BATCH_MESSAGE_TEMPLATE_RESET';